import { useState } from 'react';
import ProductCard from './ProductCard';
import { getImageUrl } from '../utils/api';

const CategorySection = ({ category, onLike, onProductClick, showHeader = true, settings = {}, isSettingEnabled = () => true, userViewMode = null }) => {
    const [isExpanded, setIsExpanded] = useState(true);

    if (!category || !category.products || category.products.length === 0) {
        return null;
    }

    // Determine display type: user preference > category default > grid_double
    const displayType = userViewMode || category.display_type || 'grid_double';

    // Get grid classes based on display type
    const getGridClasses = () => {
        switch (displayType) {
            case 'grid_single':
                return 'grid grid-cols-1 gap-4';
            case 'grid_double':
                // 2 kolon hem mobil hem desktop, büyük ekranlarda 3 kolon
                return 'grid grid-cols-2 md:grid-cols-3 gap-4';
            case 'list':
                return 'grid grid-cols-1 gap-3';
            default:
                return 'grid grid-cols-2 md:grid-cols-3 gap-4';
        }
    };

    return (
        <div className="mb-8">
            {showHeader && (
                <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    className="w-full flex items-center justify-between p-4 rounded-lg transition mb-4"
                    style={{ 
                        backgroundColor: 'var(--category-hover-color, #f9fafb)',
                        '--hover-bg': 'var(--category-bg-color, #ffffff)'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--category-bg-color, #ffffff)'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'var(--category-hover-color, #f9fafb)'}
                >
                    <div className="flex items-center space-x-4">
                        {category.image && (
                            <img
                                src={getImageUrl(category.image)}
                                alt={category.name}
                                width={48}
                                height={48}
                                className="w-12 h-12 rounded-lg object-cover"
                                loading="lazy"
                                decoding="async"
                            />
                        )}
                        <div className="text-left">
                            <h2 
                                className="text-xl font-bold"
                                style={{ color: 'var(--category-text-color, #111827)', fontFamily: 'var(--font-category-title)' }}
                            >
                                {category.name}
                            </h2>
                            {category.description && (
                                <p 
                                    className="text-sm"
                                    style={{ color: 'var(--text-secondary-color, #6b7280)', fontFamily: 'var(--font-category-description)' }}
                                >
                                    {category.description}
                                </p>
                            )}
                        </div>
                    </div>
                    <svg
                        className={`w-5 h-5 transition-transform ${
                            isExpanded ? 'transform rotate-180' : ''
                        }`}
                        style={{ color: 'var(--text-muted-color, #9ca3af)' }}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </button>
            )}

            {(isExpanded || !showHeader) && (
                <div className={getGridClasses()}>
                    {category.products.map((product) => (
                        <ProductCard
                            key={product.id}
                            product={product}
                            onLike={onLike}
                            onClick={onProductClick}
                            settings={settings}
                            isSettingEnabled={isSettingEnabled}
                            compact={displayType === 'list'}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default CategorySection;


